import { useBusinessConfig } from '@/hooks/useBusinessConfig';
import { Link } from 'react-router-dom';

export function PublicFooter() {
  const { config, loading } = useBusinessConfig();

  if (loading) {
    return (
      <footer className="py-12 mt-20 border-t border-slate-100 bg-slate-900 backdrop-blur-sm">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="animate-pulse flex flex-col items-center">
            <div className="h-4 bg-slate-700 rounded w-48 mb-4"></div>
            <div className="h-3 bg-slate-700 rounded w-64"></div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer
      className="py-12 mt-20 border-t border-slate-100 bg-slate-900 backdrop-blur-sm"
      role="contentinfo"
      aria-label="Site Footer"
    >
      <div className="max-w-4xl mx-auto px-4 text-center">
        {/* Dynamic Business Information */}
        <div className="flex flex-wrap justify-center gap-4 text-[11px] font-bold text-slate-400 uppercase tracking-widest">
          <span>&copy; {new Date().getFullYear()} {config?.biz_name || 'Local Business'}</span>
          <span className="text-slate-200 hidden sm:inline">|</span>
          <span>VaultStack Small Business Suite v1.0</span>
        </div>

        {/* Optional: Business Registration Info */}
        {config?.abn && (
          <div className="mt-2 text-[10px] font-bold text-slate-500 uppercase tracking-widest">
            ABN: {config.abn}
          </div>
        )}

        {/* Legal Links - Stripe Compliance */}
        <div className="mt-6 flex flex-wrap justify-center gap-6 text-[10px] font-bold text-slate-500 uppercase tracking-widest">
          <Link to="/privacy" className="hover:text-purple-400 transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-purple-400 transition-colors">
            Terms of Service
          </Link>
        </div>

        {/* VaultStack Pty Ltd - Required for Stripe */}
        <div className="mt-4 text-[9px] font-bold text-slate-600 uppercase tracking-wider">
          VaultStack Pty Ltd ABN 95 691 143 665
        </div>

        {/* The Murmuration Credit */}
        <p className="mt-6 text-[10px] font-black uppercase tracking-[0.4em] text-slate-300 transition-opacity hover:opacity-100 opacity-60">
          Site & Social Management by{' '}
          <a
            href="https://murmuration-site.netlify.app/Lander"
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-500 hover:text-teal-500 transition-all underline decoration-2 underline-offset-4 font-black"
          >
            Murmuration
          </a>
        </p>
      </div>
    </footer>
  );
}